import { ExclamationCircleOutlined } from "@ant-design/icons";
import { MenuInfo } from "@rc-component/menu/es/interface";
import { App as AntApp, Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import { useDeleteDashboardContact } from "../../../../../../common/api/queries";
import ActionTextIcon from "../../../../../../common/components/icons/ActionTextIcon";
import AntIcon from "../../../../../../common/components/icons/AntIcon";
import { UUID } from "../../../../../../typings/global";

const ACTION = {
  UPDATE: "update",
  DELETE: "delete",
};

interface Props {
  onUpdate: VoidFunction;
  contactId: UUID;
}

export const DashboardContactActions = ({ onUpdate, contactId }: Props) => {
  const { t } = useTranslation();
  const { modal } = AntApp.useApp();

  const deleteDashboardContact = useDeleteDashboardContact();

  const handleMenuDropdownClick = (clickInfo: MenuInfo) => {
    switch (clickInfo.key) {
      case ACTION.UPDATE:
        onUpdate();
        break;
      case ACTION.DELETE:
        modal.confirm({
          title: t("dashboard.contacts.helpers.deleteConfirm"),
          icon: <ExclamationCircleOutlined />,
          okText: t("common.yes"),
          cancelText: t("common.no"),
          okType: "danger",
          onOk: () => {
            deleteDashboardContact.mutate(contactId);
          },
        });
        break;
    }
  };

  return (
    <div style={{ position: "absolute", top: 16, right: 16 }}>
      <Dropdown
        trigger={["click"]}
        placement="bottomRight"
        menu={{
          items: [
            { key: ACTION.UPDATE, label: <ActionTextIcon icon="edit" color="blue" text={t("common.edit")} /> },
            { key: ACTION.DELETE, label: <ActionTextIcon icon="delete" color="red" text={t("common.delete")} /> },
          ],
          onClick: handleMenuDropdownClick,
        }}
      >
        <div style={{ cursor: "pointer" }}>
          <AntIcon type="more" />
        </div>
      </Dropdown>
    </div>
  );
};
